import { OrderFormValues } from "../types/cmrpreview";

export function buildCmrOrder(values: OrderFormValues) {
  const cargo = values.cargoItems || [{}];
  const totalWeight = cargo.reduce(
    (s, it) => s + (Number(it.weightKg) || 0),
    0,
  );
  const totalVolume = cargo.reduce(
    (s, it) => s + (Number(it.volumeM3) || 0),
    0,
  );

  return {
    shipmentNumber: values.shipmentNumber || "",
    pickup: { ...(values.pickup || { address: {} }) },
    delivery: { ...(values.delivery || { address: {} }) },
    carrier: { ...(values.carrier || { address: {} }) },
    cargoItems: cargo,
    pricing: values.pricing || { currency: "EUR" },
    additionalNotes: values.additionalNotes || "",
    totalWeight,
    totalVolume,
    type: values.type,
    referenceNumber: values.referenceNumber,
    assignedDriver: values.assignedDriver,
    client: values.client ? { ...values.client } : undefined,
    seaDetails: values.seaDetails || undefined,
  };
}
